import { useNavigate } from 'react-router-dom';
import supabase from '../supabaseClient';
import { LogoSVG } from './ui/FormControls';

// ── PLAN FREE: pantalla de confirmación tras activar la cuenta ───
export const RegistroCompletadoScreen = ({ currentUser, setCurrentUser, setLoginUser, setLoginPass }) => {
  const navigate = useNavigate();
  const cerrarSesion = async () => {
    await supabase.auth.signOut({ scope: "local" });
    setCurrentUser(null);
    setLoginUser("");
    setLoginPass("");
    navigate("/", { replace: true });
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="bg-white rounded-2xl shadow-xl w-full max-w-sm p-8 text-center space-y-3">
        <div className="w-14 h-14 rounded-2xl mx-auto flex items-center justify-center" style={{ background: "linear-gradient(145deg,#22c55e,#16a34a)" }}>
          <LogoSVG size={32} />
        </div>
        <h2 className="text-xl font-black text-gray-800">¡Cuenta activada!</h2>
        <p className="text-sm text-gray-500">
          {currentUser?.user ? <>Bienvenido, <strong>{currentUser.user}</strong>. </> : null}
          Tu plan gratuito ya está listo. El panel de plantillas está a punto de llegar.
        </p>
        <button onClick={() => navigate("/app/free/inicio", { replace: true })} className="w-full bg-blue-600 text-white font-bold py-3 rounded-xl hover:bg-blue-700 transition-all">
          Entrar a mi cuenta →
        </button>
        <button onClick={cerrarSesion} className="text-xs text-gray-400 hover:text-gray-600 pt-2">Cerrar sesión</button>
      </div>
    </div>
  );
};
